import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSmartBack } from "../../hooks/useSmartBack";
import { useWorkspace } from "../../context/WorkspaceContext";
import HomeShell, { HomePageContent } from "../shell/HomeShell";
import { BACKGROUNDS } from "../../config/backgrounds";
import { VERSION } from "../../config/version";
import { CUBE_GRID, isCubeNavEnabled, persistCubeNavLocal } from "../../config/cubeNavigation";
import {
  getVoiceCaptureStyle,
  persistVoiceCaptureStyleLocal,
} from "../../config/voiceCaptureStyle";
import { saveCubeNavigationEnabled, saveVoiceCaptureStyle } from "../../services/workspaceService";
import { X, ChevronLeft } from "lucide-react";
import deskGlass, { ACCENT } from "../../styles/deskGlass";

// ─── Inline SVG diagrams ───
function HierarchyDiagram() {
  return (
    <svg viewBox="0 0 400 260" style={{ width: "100%", maxWidth: "400px", margin: "20px auto", display: "block" }}>
      {/* Sala */}
      <rect x="140" y="10" width="120" height="40" rx="8" fill="#2a1a0f" stroke="#D4AF37" strokeWidth="1.5" />
      <text x="200" y="35" textAnchor="middle" fill="#D4AF37" fontSize="14" fontFamily="serif">Sala</text>
      
      {/* Lines to desks */}
      <line x1="200" y1="50" x2="200" y2="70" stroke="#666" strokeWidth="1.5" />
      <line x1="100" y1="70" x2="300" y2="70" stroke="#666" strokeWidth="1.5" />
      <line x1="100" y1="70" x2="100" y2="90" stroke="#666" strokeWidth="1.5" />
      <line x1="300" y1="70" x2="300" y2="90" stroke="#666" strokeWidth="1.5" />
      
      {/* Desks */}
      <rect x="40" y="90" width="120" height="40" rx="6" fill="#3d2314" stroke="#8B5A2B" strokeWidth="1" />
      <text x="100" y="115" textAnchor="middle" fill="#e0c090" fontSize="11" fontFamily="serif">Escritorio A</text>
      
      <rect x="240" y="90" width="120" height="40" rx="6" fill="#3d2314" stroke="#8B5A2B" strokeWidth="1" />
      <text x="300" y="115" textAnchor="middle" fill="#e0c090" fontSize="11" fontFamily="serif">Escritorio B</text>
      
      {/* Lines to drawers */}
      <line x1="100" y1="130" x2="100" y2="150" stroke="#666" strokeWidth="1" />
      <line x1="60" y1="150" x2="140" y2="150" stroke="#666" strokeWidth="1" />
      <line x1="60" y1="150" x2="60" y2="170" stroke="#666" strokeWidth="1" />
      <line x1="100" y1="150" x2="100" y2="170" stroke="#666" strokeWidth="1" />
      <line x1="140" y1="150" x2="140" y2="170" stroke="#666" strokeWidth="1" />
      
      {/* Drawers */}
      <rect x="30" y="170" width="60" height="28" rx="3" fill="#4a3728" stroke="#666" strokeWidth="0.8" />
      <text x="60" y="188" textAnchor="middle" fill="#aaa" fontSize="9">Cajón 1</text>
      
      <rect x="90" y="170" width="60" height="28" rx="3" fill="#4a3728" stroke="#666" strokeWidth="0.8" />
      <text x="120" y="188" textAnchor="middle" fill="#aaa" fontSize="9">Cajón 2</text>
      
      <rect x="150" y="170" width="60" height="28" rx="3" fill="#4a3728" stroke="#666" strokeWidth="0.8" />
      <text x="180" y="188" textAnchor="middle" fill="#aaa" fontSize="9">Cajón 3</text>
      
      {/* Lines to notebook */}
      <line x1="120" y1="198" x2="120" y2="218" stroke="#555" strokeWidth="0.8" />
      
      {/* Notebook */}
      <rect x="95" y="218" width="50" height="30" rx="4" fill="#61DAFB" stroke="#fff" strokeWidth="0.5" opacity="0.8" />
      <text x="120" y="237" textAnchor="middle" fill="#111" fontSize="8" fontWeight="bold">Notas</text>
    </svg>
  );
}

function DndDiagram() {
  return (
    <svg viewBox="0 0 400 160" style={{ width: "100%", maxWidth: "400px", margin: "20px auto", display: "block" }}>
      {/* Drawer A */}
      <rect x="20" y="20" width="160" height="120" rx="6" fill="#2a1a0f" stroke="#666" strokeWidth="1" strokeDasharray="4 2" />
      <text x="100" y="40" textAnchor="middle" fill="#888" fontSize="11">Cajón A</text>
      
      {/* Notebook in A */}
      <rect x="40" y="55" width="50" height="35" rx="4" fill="#D4AF37" opacity="0.6" />
      <text x="65" y="76" textAnchor="middle" fill="#111" fontSize="9">Cuad. 1</text>
      
      {/* Dragging notebook */}
      <rect x="165" y="60" width="50" height="35" rx="4" fill="#D4AF37" opacity="0.9" stroke="#fff" strokeWidth="1.5" />
      <text x="190" y="81" textAnchor="middle" fill="#111" fontSize="9" fontWeight="bold">Cuad. 2</text>
      
      {/* Arrow */}
      <line x1="220" y1="77" x2="260" y2="77" stroke="#D4AF37" strokeWidth="2" markerEnd="url(#arrowhead)" />
      <defs>
        <marker id="arrowhead" markerWidth="10" markerHeight="7" refX="9" refY="3.5" orient="auto">
          <polygon points="0 0, 10 3.5, 0 7" fill="#D4AF37" />
        </marker>
      </defs>
      
      {/* Drawer B */}
      <rect x="270" y="20" width="110" height="120" rx="6" fill="#2a1a0f" stroke="#D4AF37" strokeWidth="1.5" />
      <text x="325" y="40" textAnchor="middle" fill="#D4AF37" fontSize="11">Cajón B</text>
      
      {/* Notebook dropped in B */}
      <rect x="295" y="60" width="50" height="35" rx="4" fill="#D4AF37" opacity="0.9" />
      <text x="320" y="81" textAnchor="middle" fill="#111" fontSize="9" fontWeight="bold">Cuad. 2</text>
    </svg>
  );
}

function WeightDiagram() {
  return (
    <svg viewBox="0 0 400 140" style={{ width: "100%", maxWidth: "400px", margin: "20px auto", display: "block" }}>
      {/* Light notebook */}
      <rect x="40" y="30" width="60" height="40" rx="4" fill="#8B4513" opacity="0.6" />
      <text x="70" y="55" textAnchor="middle" fill="#fff" fontSize="9">Vacío</text>
      <text x="70" y="90" textAnchor="middle" fill="#888" fontSize="10">Sombra ligera</text>
      
      {/* Medium */}
      <rect x="170" y="25" width="60" height="50" rx="4" fill="#8B4513" opacity="0.8" />
      <filter id="shadow1">
        <feDropShadow dx="0" dy="4" stdDeviation="6" floodColor="#000" floodOpacity="0.4" />
      </filter>
      <rect x="170" y="25" width="60" height="50" rx="4" fill="#8B4513" filter="url(#shadow1)" />
      <text x="200" y="55" textAnchor="middle" fill="#fff" fontSize="9">5 textos</text>
      
      {/* Heavy */}
      <rect x="300" y="15" width="60" height="70" rx="4" fill="#8B4513" />
      <filter id="shadow2">
        <feDropShadow dx="0" dy="6" stdDeviation="12" floodColor="#000" floodOpacity="0.7" />
      </filter>
      <rect x="300" y="15" width="60" height="70" rx="4" fill="#8B4513" filter="url(#shadow2)" />
      <text x="330" y="55" textAnchor="middle" fill="#fff" fontSize="9">20 textos</text>
      <text x="330" y="105" textAnchor="middle" fill="#888" fontSize="10">Sombra pesada</text>
    </svg>
  );
}

function CubeNavSettings() {
  const { settings } = useWorkspace();
  const [on, setOn] = useState(() => isCubeNavEnabled(settings));
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setOn(isCubeNavEnabled(settings));
  }, [settings]);

  const toggle = async () => {
    const next = !on;
    setOn(next);
    persistCubeNavLocal(next);
    setSaving(true);
    try {
      await saveCubeNavigationEnabled(next);
    } catch (err) {
      console.error("[Help] cube nav save failed:", err);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Section title="A. Navegación cubo (experimental)" icon="🧊">
      <p>
        Vista en <strong>cuadrícula 2×3</strong> que se conecta como un cubo: deslizá horizontalmente entre columnas
        y verticalmente entre filas (desde el borde superior o inferior para no pelear con el scroll).
        Al llegar al borde, <strong>volvés al otro lado</strong> (mapa toroidal).
      </p>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "6px", margin: "12px 0", maxWidth: "220px" }}>
        {CUBE_GRID.flat().map((cell) => (
          <span key={cell.path} style={styles.cubeChip}>{cell.label}</span>
        ))}
      </div>
      <label style={{ display: "flex", alignItems: "center", gap: "10px", cursor: "pointer", marginTop: "8px" }}>
        <input type="checkbox" checked={on} onChange={toggle} disabled={saving} />
        <span><strong>Navegación cubo</strong> {saving ? "(guardando…)" : on ? "— activa" : "— desactivada"}</span>
      </label>
      <p style={{ ...styles.intro, marginTop: "10px", fontSize: "0.85rem" }}>
        Flechas del teclado también mueven entre caras. No aplica en artículos ni editor.
        Aparece una brújula abajo a la izquierda.
      </p>
    </Section>
  );
}

function VoiceCaptureSettings() {
  const { settings } = useWorkspace();
  const [style, setStyle] = useState(() => getVoiceCaptureStyle(settings));
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setStyle(getVoiceCaptureStyle(settings));
  }, [settings]);

  const choose = async (next) => {
    if (next === style) return;
    setStyle(next);
    persistVoiceCaptureStyleLocal(next);
    setSaving(true);
    try {
      await saveVoiceCaptureStyle(next);
    } catch (err) {
      console.error("[Help] voice capture style save failed:", err);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Section title="A2. Animación del micrófono" icon="🎙️">
      <p>
        Por defecto: curva de audio tipo Gemini (ondas fluidas).
        Opcional: caracteres crípticos mientras escucha (estilo anterior).
      </p>
      <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginTop: "10px" }}>
        <label style={{ display: "flex", alignItems: "center", gap: "10px", cursor: "pointer" }}>
          <input
            type="radio"
            name="voiceCaptureStyle"
            checked={style === "wave"}
            onChange={() => choose("wave")}
            disabled={saving}
          />
          <span>
            <strong>Onda</strong> — visualizador canvas (default)
          </span>
        </label>
        <label style={{ display: "flex", alignItems: "center", gap: "10px", cursor: "pointer" }}>
          <input
            type="radio"
            name="voiceCaptureStyle"
            checked={style === "cryptic"}
            onChange={() => choose("cryptic")}
            disabled={saving}
          />
          <span>
            <strong>Críptico</strong> — glifos / scramble mientras espera transcript
          </span>
        </label>
      </div>
      {saving && (
        <p style={{ ...styles.intro, marginTop: "8px", fontSize: "0.85rem" }}>guardando…</p>
      )}
    </Section>
  );
}

export default function HelpWorkspace() {
  const navigate = useNavigate();
  const goBack = useSmartBack("/dashboard");

  return (
    <HomeShell background={BACKGROUNDS.dashboard} fullHeight={false}>
    <HomePageContent wide>
      {/* Navigation & Close */}
      <div style={{ position: 'fixed', top: '20px', right: '20px', zIndex: 10000, display: 'flex', gap: '12px' }}>
        <button 
          onClick={goBack}
          style={styles.backBtn}
        >
          <ChevronLeft size={20} /> Volver
        </button>
        <button 
          onClick={() => navigate("/")}
          style={styles.closeBtn}
          title="Cerrar (Esc)"
        >
          <X size={24} />
        </button>
      </div>

      <div style={styles.container}>
      <div style={styles.versionBanner}>
        <span style={styles.versionLabel}>Guía actualizada</span>
        <span style={styles.versionNumber}>v{VERSION}</span>
        <span style={styles.versionHint}>Si ves otra versión en el header, recargá la página tras el deploy.</span>
      </div>

      <h1 style={styles.title}>Cómo usar TrufitApp</h1>
      <p style={styles.intro}>
        Tu <strong>escritorio de claridad</strong>: capturá en <strong>Hoy</strong> (página de inicio),
        guardá en <strong>Cajones</strong>, leé en <strong>Biblioteca</strong>.
        El <strong>Panel</strong> es referencia visual; corkboard, vision y atlas están congelados (solo URL directa).
      </p>

      <Section title="0. Desbloquear escritura" icon="🔒">
        <p>
          La captura y el editor empiezan <strong>cerrados</strong>: solo ves un ícono (una foto de la mascota).
          Tocalo <strong>5 veces</strong> en la sección Captura de Hoy, o el logo arriba a la izquierda.
          Queda desbloqueado en este navegador.
        </p>
      </Section>

      <CubeNavSettings />

      <VoiceCaptureSettings />

      <Section title="1. Barra inferior — qué hace cada botón" icon="🧭">
        <ul style={styles.list}>
          <li><strong>Hoy</strong> — Captura del día: máx. 3 acciones «Siguiente», diario BuJo, ideas.</li>
          <li><strong>Lectura</strong> (libro) — Cola de artículos por leer. Swipe para clasificar. Badge = pendientes.</li>
          <li><strong>Biblioteca</strong> — Todos tus artículos por fecha (archivo completo).</li>
          <li><strong>Mic</strong> — Editor con dictado por voz (Deepgram).</li>
          <li><strong>Plus</strong> — Nota rápida en modal (título, cuerpo, tags, IA). Tocá 5× si está bloqueado.</li>
          <li><strong>Cajones</strong> — Escritorio → cajón → cuaderno → texto (almacenamiento).</li>
          <li><strong>Enlaces › Panel / Atlas / Ayuda</strong> — Panel (referencia visual), mapa del vault, esta guía.</li>
        </ul>
      </Section>

      <Section title="1b. Lectura — ponerte al día" icon="📖">
        <p>
          En <strong>Hoy</strong> aparece «Lecturas pendientes» si tenés artículos sin leer.
          <strong> Ponerte al día</strong> abre el primero en modo solo lectura (sin riesgo de editar).
        </p>
        <ul style={styles.list}>
          <li><strong>Por leer</strong> — artículos nuevos o sin marcar (orden: más viejos primero).</li>
          <li>Swipe <strong>→ leído</strong> · <strong>← después</strong> en la lista o el artículo.</li>
          <li>Barra inferior en lector: Después · Leído · Repasar · Archivo · Papelera.</li>
          <li><strong>Repasar</strong> — vuelve en 1, 3, 7, 14, 30 días (repaso espaciado lite).</li>
          <li>Al scrollear ~90% se marca leído y pasa al siguiente en sesión.</li>
          <li>Markdown, tablas, código y salida CLI/LLM se renderizan con syntax highlight.</li>
        </ul>
      </Section>

      <Section title="1c. Proyectos de código (chips)" icon="💻">
        <p>
          En Hoy, bajo la categoría <strong>Código</strong>, los chips son cuadernos en Temas › Código.
          Tocá el botón <strong>≡</strong> al final de la fila para agregar, renombrar, colorear y
          <strong> arrastrar</strong> para reordenar. Se guarda en Firebase.
        </p>
      </Section>

      <Section title="2. Hoy, Panel y Biblioteca" icon="📝">
        <p>
          <strong>Hoy</strong> (<code style={styles.code}>/</code>) es tu loop principal: capturá, verificá que aparece, actuá en las 3 siguientes tareas.
          <strong>Panel</strong> (<code style={styles.code}>/dashboard</code>) define el estilo visual (glass); no es el flujo de trabajo diario.
          <strong>Biblioteca</strong> lista todo lo escrito. Corkboard, Vision y Atlas existen por URL directa pero no reciben desarrollo nuevo.
        </p>
        <p>
          <strong>Crear texto:</strong> botón <strong>+</strong> (modal rápido) o <strong>Mic</strong> / ruta <code style={styles.code}>/editor</code> (elegís escritorio, cajón y cuaderno).
          Atajo global: <strong>Ctrl+Shift+N</strong> captura desde cualquier vista.
        </p>
      </Section>

      <Section title="3. La jerarquía" icon="🏛️">
        <p>
          Todo se organiza en cuatro niveles. Pensalo como una habitación que recorréis de afuera hacia adentro:
        </p>
        <HierarchyDiagram />
        <ul style={styles.list}>
          <li><strong>Sala</strong> — El espacio total. Acá están todos tus escritorios.</li>
          <li><strong>Escritorio</strong> — Una mesa de trabajo temática. Ej: "React", "Meditación", "Finanzas".</li>
          <li><strong>Cajón</strong> — Un compartimento dentro del escritorio. Ej: "Hooks", "Jhanas".</li>
          <li><strong>Cuaderno</strong> — Un libro dentro del cajón. Tiene color propio.</li>
          <li><strong>Texto</strong> — Una página dentro del cuaderno. Tu nota, código, idea.</li>
        </ul>
      </Section>

      <Section title="4. Navegar" icon="🚶">
        <p>
          Con <strong>navegación cubo</strong> (Ayuda › sección A): deslizá entre Hoy, Panel, Cajones, Biblioteca, Atlas y Ayuda.
          Horizontal en cualquier zona; vertical desde el borde de pantalla. Flechas ← → ↑ ↓ en desktop.
        </p>
        <p>
          En <strong>Cajones</strong>: deslizá o usá la barra inferior (Escritorios / Cajones / Cuadernos / Páginas).
          En el <strong>header</strong>: breadcrumb <code style={styles.code}>Hoy › Panel › …</code> — cada nivel es un clic.
        </p>
        <p>
          En el <strong>Panel</strong>: deslizá horizontalmente, usá <strong>← →</strong>, <strong>Shift + rueda del mouse</strong>,
          los puntos de abajo, o los botones Anterior/Siguiente en la slide Guía.
        </p>
        <p>
          <strong>Búsqueda:</strong> icono lupa o <strong>Ctrl+K</strong>.
        </p>
      </Section>

      <Section title="5. Crear cosas" icon="➕">
        <p>En cada nivel hay un botón verde para agregar:</p>
        <ul style={styles.list}>
          <li><strong>+ Escritorio</strong> — en la Sala</li>
          <li><strong>+ Cajón</strong> — dentro de un escritorio</li>
          <li><strong>+ Cuaderno</strong> — dentro de un cajón abierto</li>
          <li><strong>+ Texto</strong> — dentro de un cuaderno. Se abre un editor con título y contenido.</li>
        </ul>
        <p>
          Escribí en el editor y apretá <strong>Guardar</strong>. El texto se guarda en la nube instantáneamente.
        </p>
      </Section>

      <Section title="6. Mover y organizar" icon="✋">
        <p>
          Podés <strong>arrastrar</strong> cuadernos de un cajón a otro. Abriendo varios cajones a la vez,
          el cuaderno flota entre ellos.
        </p>
        <DndDiagram />
        <p>
          También podés <strong>reordenar</strong> textos dentro de un cuaderno arrastrándolos arriba o abajo.
          Los escritorios se reordenan en la Sala de la misma forma.
        </p>
        <p style={styles.tip}>
          💡 Los escritorios son pesados — no se arrastran entre salas (por ahora).
        </p>
      </Section>

      <Section title="7. Editar y leer" icon="✎">
        <p>
          Al abrir un texto: <strong>Editar</strong> en el lector → <code style={styles.code}>/editor</code> con el contenido cargado.
          En Cajones: lápiz o clic en el relato abre el lector; desde ahí editás.
        </p>
      </Section>

      <Section title="8. El peso visual" icon="⚖️">
        <p>
          Este espacio no es solo funcional — es <strong>corpóreo</strong>. La interfaz refleja la densidad
          de tus ideas para que tu sistema límbico sepa dónde está todo sin pensarlo:
        </p>
        <WeightDiagram />
        <ul style={styles.list}>
          <li>Los <strong>textos largos</strong> son cartas más altas.</li>
          <li>Los <strong>cuadernos con más textos</strong> proyectan sombra más pesada.</li>
          <li>Los <strong>cajones llenos</strong> se abren más lento, como cajones reales.</li>
          <li>Los <strong>escritorios con más cajones</strong> ocupan más espacio visual.</li>
        </ul>
        <p>
          Esto no es decorativo — es <strong>cognición distribuida</strong>. Tu cerebro delega
          la memoria espacial a la interfaz.
        </p>
      </Section>

      <Section title="9. Atajos de teclado" icon="⌨️">
        <ul style={styles.list}>
          <li><strong>Ctrl+K</strong> — Buscar en el vault</li>
          <li><strong>Ctrl+Shift+N</strong> — Captura rápida global</li>
          <li><strong>← →</strong> — Cambiar slide en el Panel</li>
          <li><strong>Shift + rueda</strong> — Panel en desktop</li>
          <li><strong>Escape</strong> — Cierra búsqueda, editor o modales</li>
        </ul>
      </Section>

      <Section title="10. Más documentación" icon="📄">
        <p>
          Arquitectura técnica, rutas y conflictos entre versiones viejas/nuevas:
          <code style={styles.code}>frontend/docs/ARCHITECTURE.md</code> en el repositorio.
        </p>
      </Section>

      <div style={styles.footer}>
        <p>
          Si algo no funciona, compará la versión del header con <strong>v{VERSION}</strong> de esta guía.
        </p>
        <p style={{ opacity: 0.7, fontSize: "0.85rem", marginTop: "10px" }}>
          TrufitApp v{VERSION} — Guía del Vault
        </p>
      </div>
    </div>
    </HomePageContent>
    </HomeShell>
  );
}

function Section({ title, icon, children }) {
  return (
    <div style={styles.section}>
      <h2 style={styles.sectionTitle}>
        <span style={{ marginRight: "10px" }}>{icon}</span>
        {title}
      </h2>
      {children}
    </div>
  );
}

const styles = {
  container: {
    ...deskGlass.deskContent,
    padding: "80px 20px 40px",
    color: "#e0e0e0",
    fontFamily: "'Inter', system-ui, sans-serif",
    lineHeight: 1.6,
    fontSize: "0.95rem",
  },
  versionBanner: {
    ...deskGlass.glassSection,
    alignItems: "center",
    textAlign: "center",
    marginBottom: "20px",
    padding: "14px 18px",
  },
  versionLabel: {
    fontSize: "0.65rem",
    textTransform: "uppercase",
    letterSpacing: "2px",
    color: "rgba(255,255,255,0.5)",
    fontWeight: "bold",
  },
  versionNumber: {
    fontSize: "1.4rem",
    fontWeight: "800",
    color: ACCENT,
    fontFamily: "monospace",
  },
  versionHint: {
    ...deskGlass.subtext,
    fontSize: "0.75rem",
    maxWidth: "320px",
  },
  title: {
    ...deskGlass.greeting,
    color: ACCENT,
    fontWeight: "normal",
    textAlign: "center",
  },
  intro: {
    textAlign: "center",
    ...deskGlass.subtext,
    fontStyle: "italic",
    marginBottom: "32px",
    fontSize: "1.05rem",
  },
  section: {
    ...deskGlass.glassSection,
    marginBottom: "20px",
  },
  sectionTitle: {
    ...deskGlass.glassTitle,
    color: ACCENT,
    fontSize: "1rem",
    opacity: 1,
    marginTop: 0,
    marginBottom: "12px",
    display: "flex",
    alignItems: "center",
    letterSpacing: "1px",
  },
  list: {
    paddingLeft: "20px",
    color: "#ccc",
  },
  code: {
    background: "rgba(212,175,55,0.1)",
    padding: "2px 8px",
    borderRadius: "4px",
    fontFamily: "monospace",
    fontSize: "0.9rem",
    color: "#D4AF37",
  },
  tip: {
    background: "rgba(212,175,55,0.08)",
    borderLeft: "3px solid #D4AF37",
    padding: "10px 14px",
    borderRadius: "0 8px 8px 0",
    marginTop: "12px",
    color: "#bbb",
    fontSize: "0.9rem",
  },
  cubeChip: {
    fontSize: "0.7rem",
    padding: "4px 8px",
    borderRadius: "6px",
    border: "1px solid rgba(212,175,55,0.25)",
    background: "rgba(255,255,255,0.05)",
    color: "rgba(255,255,255,0.75)",
  },
  footer: {
    ...deskGlass.glassSection,
    textAlign: "center",
    marginTop: "40px",
    color: deskGlass.subtext.color,
    fontStyle: "italic",
  },
  backBtn: {
    ...deskGlass.viewToggle,
    color: ACCENT,
  },
  closeBtn: {
    ...deskGlass.glassActionBtn,
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    color: ACCENT,
    borderColor: "rgba(212,175,55,0.4)",
    background: "rgba(212,175,55,0.15)",
  },
};
